// extracted by mini-css-extract-plugin
module.exports = {"Arc":"ArcProgressBar_Arc__nbXaR","Outline":"ArcProgressBar_Outline__3ff-8","Progress":"ArcProgressBar_Progress__ozD42"};